module.exports = "https://static.wmbcdn.com/uniweb/images/33937ac2300bf704176b20df5a022196.svg";